import errors from '../../feedback/errors/locales/fr.json';

const frLocales = {
  errors,
};

export default frLocales;
